import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "flex items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_4 = { class: "py-4 px-5 md:px-6 border-b md:flex items-center justify-between" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "text-lg md:text-2xl font-medium text-gray-900" }
const _hoisted_7 = { class: "flex items-center pt-1 ml-2" }
const _hoisted_8 = { class: "flex justify-end items-center" }
const _hoisted_9 = { class: "divide-y" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShieldCheckIcon = _resolveComponent("ShieldCheckIcon")!
  const _component_BanIcon = _resolveComponent("BanIcon")!
  const _component_StarIcon = _resolveComponent("StarIcon")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_OriginatorOverview = _resolveComponent("OriginatorOverview")!
  const _component_CreditBoxNavigation = _resolveComponent("CreditBoxNavigation")!
  const _component_CreditBox = _resolveComponent("CreditBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "fixed z-10 inset-0 overflow-y-auto",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal('ModalOriginator')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.localOriginator.isVerified)
                ? (_openBlock(), _createBlock(_component_ShieldCheckIcon, {
                    key: 0,
                    class: "w-5 h-5 mt-0.5 mr-1 text-blue-600"
                  }))
                : _createCommentVNode("", true),
              (_ctx.localOriginator.deleted)
                ? (_openBlock(), _createBlock(_component_BanIcon, {
                    key: 1,
                    class: "w-5 h-5 mt-0.5 mr-1 text-red-700"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.localOriginator.name), 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_component_StarIcon, {
                    key: n,
                    class: _normalizeClass(["cursor-pointer w-4 h-4 mr-1", {
                    'text-yellow-500': _ctx.localOriginator.rating && n <= _ctx.localOriginator.rating,
                    'text-gray-400': !_ctx.localOriginator.rating || n > _ctx.localOriginator.rating
                  }]),
                    onClick: ($event: any) => (_ctx.updateRating(n))
                  }, null, 8, ["class", "onClick"])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: `/originator/${_ctx.localOriginator.id}`,
                class: "border hover:border-gray-400 bg-white rounded-md text-sm px-3 py-1.5 mr-2 flex items-center",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EyeIcon, { class: "w-3 h-3 mr-2" }),
                  _createTextVNode(" Extended view ")
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("button", {
                class: "bg-sky text-white rounded-md text-sm px-3 py-1.5 flex items-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('ModalNewOriginator', { originator: _ctx.localOriginator, editor: true })))
              }, [
                _createVNode(_component_PencilIcon, { class: "w-3 h-3 mr-2" }),
                _createTextVNode(" Edit originator ")
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal('ModalOriginator')))
              }, [
                _createVNode(_component_XIcon, { class: "w-5 h-5" })
              ])
            ])
          ]),
          _createVNode(_component_OriginatorOverview, { originator: _ctx.localOriginator }, null, 8, ["originator"]),
          _createVNode(_component_CreditBoxNavigation, {
            modelValue: _ctx.activeTabIndex,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTabIndex) = $event)),
            creditBoxes: _ctx.localOriginator.creditBoxes
          }, null, 8, ["modelValue", "creditBoxes"]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createBlock(_component_CreditBox, {
              data: _ctx.creditBoxes[_ctx.activeTabIndex]?.value || {},
              name: _ctx.creditBoxes[_ctx.activeTabIndex]?.name || '',
              key: _ctx.activeTabIndex,
              originator: _ctx.localOriginator
            }, null, 8, ["data", "name", "originator"]))
          ])
        ])
      ])
    ])
  ]))
}